import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {
    ChaneLogResponse,
    FieldsResponse, InvocationLogResponse, EntityLogResponse
} from "../../models/logger/logger.data";

export class LoggerService {
    api: AxiosInstance = API;

    getEntitiesList(): Promise<string[]> {
        return this.api.get<string[]>("logger/change-logs/entities").then(x => x.data);
    }

    getChangeLogFields(className: string): Promise<FieldsResponse> {
        return this.api.get<FieldsResponse>("logger/change-logs/fields", {
            params: {
                className: className
            }
        }).then(x => x.data);
    }

    getChangeLogs(className: string, identity: string, start: string, end: string): Promise<ChaneLogResponse> {
        return this.api.get<ChaneLogResponse>("logger/change-logs", {
            params: {
                className: className,
                identity: identity,
                start: start,
                end: end
            }
        }).then(x => x.data);
    }

    getInvocationLog(invocation: string): Promise<InvocationLogResponse> {
        return this.api.get<InvocationLogResponse>("logger/log/invocation", {
            params: {
                invocation: invocation
            }
        }).then(x => x.data);
    }

    getEntityLog(className: string, identity: string): Promise<EntityLogResponse> {
        return this.api.get<EntityLogResponse>("logger/log/entity", {
            params: {
                className: className,
                identity: identity,
            }
        }).then(x => x.data);
    }
}

export const loggerService = new LoggerService();
